export const severity = {
  null: "Non défini",
};
